import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useCustDiagStore } from "../../contexts/RootStoreProvider";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Alert,
  Typography,
} from "@mui/material";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import WizardHeader from "../Wizard/WizardHeader";

const Resolution = (props: any) => {
  const custDiagStore = useCustDiagStore();
  let params = useParams();

  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [orderID, setOrderID] = useState(false);

  const createOrder = (data: any, actions: any) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "1 Hour TT Consultancy",
            amount: {
              currency_code: "GBP",
              value: 20,
            },
          },
        ],
        // not needed if a shipping address is actually needed
        application_context: {
          shipping_preference: "NO_SHIPPING",
        },
      })
      .then((orderID) => {
        setOrderID(orderID);
        return orderID;
      });
  };

  // check Approval
  const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      const { payer } = details;
      console.log(payer);
      setSuccess(true);
    });
  };
  //capture likely error
  const onError = (data, actions) => {
    setErrorMessage("An Error occured with your payment ");
  };

  useEffect(() => {
    if (params.id !== undefined) {
      custDiagStore.getResolutionDetails(params.id);
    }
  }, []);

  const style = { backgroundColor: "#001f3d", color: "white" };

  return (
    <>
      <WizardHeader title={""} />
      <Card style={style}>
        <CardHeader subheader="Resolution Detail" />
        <Divider />
        <CardContent>
          <div>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography align="center" variant={"h2"} gutterBottom>
                  <b>{custDiagStore.resolution.res_cap_quote}</b>
                </Typography>
                {/* <div>
                <br />
                IMAGE
                <br />
              </div> */}

                <div>
                  <Typography align="center" variant={"h5"} gutterBottom>
                    <b>{custDiagStore.resolution.causing_prob_heading}</b>
                  </Typography>
                </div>
                <Typography align="justify" variant={"h6"} gutterBottom>
                  <div>{custDiagStore.resolution.causing_prob_txt}</div>
                </Typography>
                <div>
                  <Typography align="center" variant={"h5"} gutterBottom>
                    <b>{custDiagStore.resolution.sug_adv_heading}</b>
                  </Typography>
                </div>
                <br />
                <Typography align="justify" variant={"h6"} gutterBottom>
                  <div>{custDiagStore.resolution.sug_adv_txt}</div>

                  <div>{custDiagStore.resolution.sug_adv_txt_2}</div>

                  <div>{custDiagStore.resolution.sug_adv_txt_3}</div>
                </Typography>

                <div>
                  <Typography align="center" variant={"h5"} gutterBottom>
                    <b>{custDiagStore.resolution.serv_del_opt_heading}</b>
                  </Typography>
                </div>
                <br />
                <Typography align="center" variant={"h6"} gutterBottom>
                  <div>
                    Onsite:{" "}
                    <b>
                      {custDiagStore.resolution.onsite === "1" ? "Yes" : "No"}
                    </b>{" "}
                  </div>
                  <div>
                    Offsite:{" "}
                    <b>
                      {custDiagStore.resolution.offsite === "1" ? "Yes" : "No"}
                    </b>
                  </div>
                  <div>
                    Remote:{" "}
                    <b>
                      {custDiagStore.resolution.remote === "1" ? "Yes" : "No"}
                    </b>
                  </div>
                  <div>
                    PhoneCall:{" "}
                    <b>
                      {custDiagStore.resolution.phonecall === "1"
                        ? "Yes"
                        : "No"}
                    </b>
                  </div>
                </Typography>
                {/* {success === true && success !== undefined ? (
                <>
                  <Alert severity="success">
                    Thank you , Payment Received, Order No: {orderID}
                  </Alert>
                </>
              ) : (
                <Alert severity="error">
                  Unfortunatley there was an error with your payment:{" "}
                  {ErrorMessage}
                </Alert>
              )} */}
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid
                item
                direction="row"
                justifyContent="center"
                alignItems="center"
                xs={"auto"}
              >
                <PayPalScriptProvider
                  options={{
                    "client-id":
                      "AaTIzaNZCC7VpG5m5-txpOMIASgnxOpjHDGoA8DsSewhbtPri-Lj8fNAkXE1blmqQquojUOIunr89ytl",
                    currency: "GBP",
                  }}
                >
                  <div>
                    <div className="wrapper">
                      <div className="product-info">
                        <div className="product-price-btn">
                          <p>
                            <Typography
                              align="center"
                              variant={"h6"}
                              gutterBottom
                            >
                              <span>1 Hour Consultation : £30 </span>
                            </Typography>
                          </p>
                          <PayPalButtons
                            style={{ layout: "vertical" }}
                            createOrder={createOrder}
                            onApprove={onApprove}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </PayPalScriptProvider>
              </Grid>{" "}
            </Grid>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

Resolution.propTypes = {};
export default observer(Resolution);
